<template>
  <main class="page pto">
    <AppBack :on-back="onBack" />

    <AppPageHeader title="Подписание работ" />

    <section class="section page__content">
      <ThePagePreloader
        v-if="isLoading"
        position="component"
      />

      <div v-if="!isEdit && !isLoading" class="info">
        <PTOProjectTitle />

        <AppButtonSmEdit
          v-if="$store.getters.rightsPtoAll"
          class="info__btn-edit"
          title="Редактировать"
          @click.native="toggleIsEdit"
        />

        <ul class="info__list-edit">
          <PtoInfoListItem
            label-text="План, объем"
            :text="currentItem.plan_volume ? currentItem.plan_volume : '-'"
          />

          <PtoInfoListItem
            label-text="План, руб."
            :text="currentItem.plan ? priceFormat(currentItem.plan) : '-'"
          />

          <PtoInfoListItem
            label-text="Ед.изм"
            :text="currentItem.measure_unit_id ? getMeasureUnitList(currentItem.measure_unit_id) : '-'"
          />

          <PtoInfoListItem
            label-text="Подписано, объем"
            :text="currentItem.sign_volume ? currentItem.sign_volume : '-'"
          />

          <PtoInfoListItem
            label-text="Дата начала"
            :text="currentItem.start_date ? currentItem.start_date : '-'"
          />

          <PtoInfoListItem
            label-text="Дата окончания"
            :text="currentItem.finish_date ? currentItem.finish_date : '-'"
          />

          <PtoInfoListItem
            label-text="Подписано, руб. (в ценах 2001)"
            :text="currentItem.sign_2001 ? priceFormat(currentItem.sign_2001) : '-'"
          />

          <PtoInfoListItem
            label-text="№ КС-2"
            :text="currentItem.number_ks ? currentItem.number_ks : '-'"
          />

          <PtoInfoListItem
            label-text="Подписано, руб. (в тек. ценах без НДС)"
            :text="currentItem.sign_without_nds ? priceFormat(currentItem.sign_without_nds) : '-'"
          />

          <PtoInfoListItem
            label-text="№ сч-ф"
            :text="currentItem.account_number ? currentItem.account_number : '-'"
          />

          <PtoInfoListItem
            label-text="Подписано, руб. (в тек. ценах с НДС)"
            :text="currentItem.sign_with_nds ? priceFormat(currentItem.sign_with_nds) : '-'"
          />

          <PtoInfoListItem
            label-text="Стоимость (в тек.ценах без НДС)"
            :text="currentItem.current_price ? priceFormat(currentItem.current_price) : '-'"
          />

          <PtoInfoListItem
            label-text="Трудозатраты"
            :text="currentItem.labor_costs ? priceFormat(currentItem.labor_costs) : '-'"
          />

          <PtoInfoListItem
            label-text="ФОТ"
            :text="currentItem.fot ? priceFormat(currentItem.fot) : '-'"
          />

          <PtoInfoListItem
            label-text="Собственное производство"
            :text="currentItem.is_own_production ? getYesOrNo(currentItem.is_own_production) : 'Нет'"
          />

          <PtoInfoListItem
            label-text="Доплата ФОТ"
            :text="currentItem.is_surcharge_fot ? getYesOrNo(currentItem.is_surcharge_fot) : 'Нет'"
          />
        </ul>
        <DropdownJobList
          v-if='jobs.length'
          class="mb-30"
          :job-list="jobs"
          disabled-remove
        />
      </div>

      <FormPtoProjectWorkSign
        v-if="isEdit"
        :form-data="currentItem"
        is-edit
        :is-sending="isSendingRequest"
        @updateFot='updateFot'
        @request="sendPutRequest"
        @cancel="toggleIsEdit"
      />
    </section>

        <AppTabsSlider
          v-if='currentItem.is_surcharge_fot || currentItem.is_own_production'
          :space-between="20"
          :tabs="showTabs"
        />

        <router-view />
  </main>
</template>

<script>
import AppBack from '@/components/page/AppBack.vue'
import AppButtonSmEdit from '@/components/page/button/AppButtonSmEdit'
import AppTabsSlider from '@/components/page/tabs/AppTabsSlider'
import AppPageHeader from '@/components/page/AppPageHeader'
import FormPtoProjectWorkSign from '@/components/pto/form/FormPtoProjectWorkSign'
import PtoInfoListItem from '@/components/pto/listItem/PtoInfoListItem'
import PTOProjectTitle from '@/components/pto/title/PTOProjectTitle'
import ThePagePreloader from '@/components/page/ThePagePreloader'
import DropdownJobList from '@/components/pto/Job/DropdownJobList'

import { MIXIN_PTO_PROJECT_PAGE_UPDATE } from '@/mixins/module/pto/project/mixinPTOPageUpdate'
import { priceFormat } from '@/utils/form/priceFormat'
import { mapActions, mapGetters, mapState } from 'vuex'
import { getYesOrNo } from '@/utils/string/getYesOrNo'
import { getUserFullName } from '@/utils/user'
import { prepareFormDataJob } from '@/utils/form/pto/prepareFormDataJob'
import { goToPage } from '@/utils/router'

export default {
  name: 'PtoProjectWorkSignUpdate',
  components: {
    AppBack,
    AppButtonSmEdit,
    AppPageHeader,
    AppTabsSlider,
    FormPtoProjectWorkSign,
    PtoInfoListItem,
    PTOProjectTitle,
    ThePagePreloader,
    DropdownJobList
  },
  mixins: [MIXIN_PTO_PROJECT_PAGE_UPDATE],
  data () {
    return {
      jobs: []
    }
  },
  computed: {
    ...mapGetters('pto/project/estimate/workSign', {
      currentItem: 'getCurrentItem',
      isLoading: 'getIsLoading'
    }),
    ...mapState('handbook/pto', {
      measureUnitList: 'measureUnitList',
      projectPTOJobs: 'projectPTOJobList'
    }),
    initFilter () {
      return {
        work_sign_id: this.$route.params.id
      }
    },
    showTabs () {
      return [
        {
          key: '',
          name: 'Собственное производство',
          routeName: 'PtoProjectWorkSignUpdateOwn',
          disabled: !this.currentItem.is_own_production
        },
        {
          key: '',
          name: 'Доплаты ФОТ',
          routeName: 'PtoProjectWorkSignUpdateFot',
          disabled: !this.currentItem.is_surcharge_fot
        }
      ]
    }
  },
  async beforeMount () {
    await this.GETProjectPTOJobList({ projectId: this.$route.params.projectId })
    await this.GETMeasureUnitList({})
    if (this.currentItem.job_id) {
      const job = this.projectPTOJobs.find(item => item.id === this.currentItem.job_id)
      const transformJob = prepareFormDataJob(job)
      this.jobs = [transformJob]
    }
    if (this.currentItem.is_own_production) {
      this.$router.push({ name: 'PtoProjectWorkSignUpdateOwn' })
    } else if (this.currentItem.is_surcharge_fot) {
      this.$router.push({ name: 'PtoProjectWorkSignUpdateFot' })
    }
  },
  methods: {
    ...mapActions('pto/project/estimate/workSign', {
      loadOneItem: 'loadOneItem',
      updateItem: 'updateItem'
    }),
    ...mapActions('handbook/pto', {
      GETProjectPTOJobList: 'GETProjectPTOJobList',
      GETMeasureUnitList: 'GETMeasureUnitList'
    }),
    updateFot (sum) {
      setTimeout(() => {
        this.currentItem.fot = sum
      }, 1000)
    },
    getMeasureUnitList (id) {
      return this.measureUnitList.find(item => item.id === id)?.name
    },
    onBack () {
      return goToPage('PtoProjectEstimateUpdate', { projectId: this.$route.params.projectId, id: this.currentItem.estimate_id })
    },
    getYesOrNo,
    getUserFullName,
    priceFormat
  }
}
</script>
